import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const InvoiceUploadErrorModal = (props: any) => {
  const { failureReason, handleOk, handleCancel, isVisible } = props;
  const { t } = useTranslation();

  return (
    <Modal
      title={t('Error')}
      visible={isVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={t('Continue')}
      cancelText={t('Back')}
      width={400}
    >
      <div>
        <div>{t('QR validation failed. Do you still want to continue?')}</div>
        {failureReason && <div style={{ marginTop: '8px' }}>{t('Error message')}: {failureReason}</div>}
      </div>
    </Modal>
  );
};

export default InvoiceUploadErrorModal;
